import { motion } from 'framer-motion'
import { Section } from '@/components/ui/Section'
import { Container } from '@/components/ui/Container'
import { DecoratedHeader } from '@/components/ui/DecoratedHeader'
import { WhyGuestPillarCard } from '@/components/home/WhyGuestPillarCard'
import { whyGuestsPillars } from '@/content/whyGuestsPillars'
import { staggerContainer, staggerItem } from '@/lib/motion'

export function HomeWhySection() {
  return (
    <Section>
      <Container>
        <DecoratedHeader
          size="section"
          eyebrow="Why"
          eyebrowAccent="Rodeo Nails"
          title="Why guests choose us"
          description="Straightforward reasons people come back. No pressure, no script."
          sparkle={false}
        />
        <motion.ul
          className="mt-10 grid list-none gap-7 p-0 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-40px' }}
        >
          {whyGuestsPillars.map((p) => (
            <motion.li key={p.id} variants={staggerItem} className="min-h-0">
              <WhyGuestPillarCard pillar={p} />
            </motion.li>
          ))}
        </motion.ul>
      </Container>
    </Section>
  )
}
